export class TokenResponse {
    'accessToken';
    'expirationSeconds';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "accessToken",
            "baseName": "accessToken",
            "type": "string",
            "format": ""
        },
        {
            "name": "expirationSeconds",
            "baseName": "expirationSeconds",
            "type": "number",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return TokenResponse.attributeTypeMap;
    }
    constructor() {
    }
}
